export default __webpack_public_path__ + "static/media/branding-logo.246455b7.svg";